import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import styledNormalize from 'styled-normalize';
import { injectGlobal } from 'styled-components';
import { Provider } from 'mobx-react';
import { ThemeProvider } from 'emotion-theming';
import ReactBreakpoints from 'react-breakpoints';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-dropdown-tree-select/dist/styles.css';
import registerServiceWorker from './registerServiceWorker';
import Routes from './routes';
import { theme } from './constants';
import stores from './stores';
import BifmUserRoutes from './BifmUserRoutes';

Sentry.init({
  dsn: 'https://8146d8ada11b442e8316a5792701f4e7@o1175759.ingest.sentry.io/6272873',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.1,
});

process.env.APP_NAME === 'TRIPLEMARS'
  ? require('../scss/index.scss')
  : require('../scss/indexSalefreaks.scss');

injectGlobal`
  ${styledNormalize}

.fade-enter-active {
  animation-name: antSlideUpIn;
}

.fade-exit-active {
  animation-name: antSlideUpOut;
}
.tutorial-popover {
  .ant-popover-arrow {
    background-color: ${theme.colors.blueMed};
  }
  .ant-popover-inner {
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.blueMed};
  }
}
`;

const breakpoints = {
  mobile: 380,
  mobileLandscape: 500,
  tabletMini: 653,
  tablet: 820,
  tabletIntermediate: 900,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920,
};

Promise.all(stores.uiStore.initOnLoad()).then(() => {
  ReactDOM.render(
    <Provider
      {...stores.domainStore}
      {...stores.uiStore}
      router={stores.uiStore.routingStore.browserHistory}
    >
      <ThemeProvider theme={theme}>
        <ReactBreakpoints breakpoints={breakpoints}>
          {stores.uiStore.sessionStore.isBifmUser ? <BifmUserRoutes /> : <Routes />}
        </ReactBreakpoints>
      </ThemeProvider>
    </Provider>,
    document.getElementById('root'),
  );
  registerServiceWorker();
});
